import * as CL from '@design-system/component-library';
import {
  scheduledChangeActiveDisclaimerMsg,
  scheduledChangeMsg,
  scheduledChangeScheduledDisclaimerMsg,
  t,
} from '../../../common/i18n/index.js';
import { formatDefinedTimestampToDDMMYYYY } from '../../../common/utils/dateUtils.js';

export enum SubscriptionVersion {
  ACTIVE = 'ACTIVE',
  SCHEDULED = 'SCHEDULED',
}

interface SubscriptionScheduledChangeDisclaimerProps {
  scheduledChangeTimestamp: number;
  subscriptionVersion: SubscriptionVersion;
}

export const SubscriptionScheduledChangeDisclaimer = ({
  scheduledChangeTimestamp,
  subscriptionVersion,
}: SubscriptionScheduledChangeDisclaimerProps) => {
  const date = formatDefinedTimestampToDDMMYYYY(scheduledChangeTimestamp);
  if (subscriptionVersion === SubscriptionVersion.ACTIVE) {
    return (
      <CL.Disclaimer
        title={t.N4LE(scheduledChangeMsg)}
        disclaimerType="info"
        icon={<CL.Icon icon="information" />}
        showCloseButton={false}
        text={t.FTM8(scheduledChangeActiveDisclaimerMsg, date)}
        visible
      />
    );
  }
  return (
    <CL.Disclaimer
      title={`${t.N4LE(scheduledChangeMsg)} ${date}`}
      disclaimerType="warning"
      icon={<CL.Icon icon="calendar-time" />}
      showCloseButton={false}
      text={t.HEGD(scheduledChangeScheduledDisclaimerMsg, date)}
      visible
    />
  );
};
